import React from 'react';
import './CheckboxAsButton.css';

// Remove internal useState. Use the 'checked' prop directly.
const CheckboxAsButton = ({ children = {}, onChange = () => { }, checked = false }) => {

  const handleCheckboxChange = () => {
    // Just call the parent's onChange with the toggled value
    onChange({ ...children, checked: !checked });
  };

  return (
    <label className={`checkbox-button ${checked ? 'checked' : ''}`}>
      <input
        type="checkbox"
        className="hidden-checkbox"
        checked={checked}
        onChange={handleCheckboxChange}
      />
      {children.name}
    </label>
  );
};

export default CheckboxAsButton;